// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../font/static/Montserrat-ExtraBold.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
@font-face {
    font-family: 'MonstserratBlack';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('truetype')
   
}
/* src: url('../font/Montserrat-VariableFont_wght.ttf') format ('truetype');
src: url ('../font/static/Montserrat-ExtraBold.ttf') format('truetype'); */



.AutentificacaoCadastro_page__vFXEu{
    background-color: #9E184B;
    background-size: auto auto;
    width: 100%;
    height: 100%;
    z-index: -1;
}

.AutentificacaoCadastro_container__LbQwc{
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
}

.AutentificacaoCadastro_page__vFXEu p{
    color: #543A20;

}


.AutentificacaoCadastro_sect__UVwFQ{
    width: 40%;
    min-width: 600px;
    height: 680px;
    background-color: #EBE9E2;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    padding: 10px;
    box-shadow: rgba(0, 0, 0, 0.3) 0px 19px 38px, rgba(0, 0, 0, 0.22) 0px 15px 12px;
}

.AutentificacaoCadastro_imagemCafe__T\\+Lqa{
    position: absolute; 
    width: 25%;
    top: 0;
    right: 0;
}

.AutentificacaoCadastro_tituloYouCofee__XAMvD{
   width: 100%;
   text-align: center;
   
   
}

.AutentificacaoCadastro_tituloYouCoffee__XwWPB h1{
    width: 100%;
    font-size: 55px;
    margin-top: 0;
    margin-bottom: 20px;
    color:#9E184B;
    font-family: 'MonstserratBlack', sans-serif;
}

@media (max-width: 480px) {
    .AutentificacaoCadastro_imagemCafe__T\\+Lqa{
        width: 0%;
        top: 0;
        right: 0;
    }

    .AutentificacaoCadastro_imagemTopo__Ip8u7{
     align-items: center;   
     margin-left: 16%;
    }
 }

.AutentificacaoCadastro_imagemLogoYoux__WwTB5{
    width: 9%;
    top: 0;
    left: 0;
    margin-top: 60px;
    margin-left: 70px;
    position: absolute;
}

.AutentificacaoCadastro_imagemXicara__CtQjc{
    position: absolute;
     width: 19%;
    bottom: 0;
    left: 0;
    border-radius: 20%;
}

.AutentificacaoCadastro_buttonEdit__h0Iut{
    width: 67%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-top: 50px;
}

.AutentificacaoCadastro_caixaInput__N1MuA{
    width: 100%;
    margin-top: 10px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    
}

.AutentificacaoCadastro_subTitulo__RQ9vW{
    font-size: 20px;
    margin-bottom: 6px;
}

.AutentificacaoCadastro_caixaAllInput__dq\\+aL{
    width: 67%;
}

`, "",{"version":3,"sources":["webpack://./src/paginas/Autentificacao/AutentificacaoCadastro.module.css"],"names":[],"mappings":";AACA;IACI,+BAA+B;IAC/B;;AAEJ;AACA;0EAC0E;;;;AAI1E;IACI,yBAAyB;IACzB,0BAA0B;IAC1B,WAAW;IACX,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,cAAc;;AAElB;;;AAGA;IACI,UAAU;IACV,gBAAgB;IAChB,aAAa;IACb,yBAAyB;IACzB,aAAa;IACb,uBAAuB;IACvB,sBAAsB;IACtB,mBAAmB;IACnB,aAAa;IACb,+EAA+E;AACnF;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,MAAM;IACN,QAAQ;AACZ;;AAEA;GACG,WAAW;GACX,kBAAkB;;;AAGrB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,aAAa;IACb,2CAA2C;AAC/C;;AAEA;IACI;QACI,SAAS;QACT,MAAM;QACN,QAAQ;IACZ;;IAEA;KACC,mBAAmB;KACnB,gBAAgB;IACjB;CACH;;AAED;IACI,SAAS;IACT,MAAM;IACN,OAAO;IACP,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;KACjB,UAAU;IACX,SAAS;IACT,OAAO;IACP,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;;AAEvB;;AAEA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,UAAU;AACd","sourcesContent":["\n@font-face {\n    font-family: 'MonstserratBlack';\n    src: url('../../font/static/Montserrat-ExtraBold.ttf') format('truetype')\n   \n}\n/* src: url('../font/Montserrat-VariableFont_wght.ttf') format ('truetype');\nsrc: url ('../font/static/Montserrat-ExtraBold.ttf') format('truetype'); */\n\n\n\n.page{\n    background-color: #9E184B;\n    background-size: auto auto;\n    width: 100%;\n    height: 100%;\n    z-index: -1;\n}\n\n.container{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 100vh;\n}\n\n.page p{\n    color: #543A20;\n\n}\n\n\n.sect{\n    width: 40%;\n    min-width: 600px;\n    height: 680px;\n    background-color: #EBE9E2;\n    display: flex;\n    justify-content: center;\n    flex-direction: column;\n    align-items: center;\n    padding: 10px;\n    box-shadow: rgba(0, 0, 0, 0.3) 0px 19px 38px, rgba(0, 0, 0, 0.22) 0px 15px 12px;\n}\n\n.imagemCafe{\n    position: absolute; \n    width: 25%;\n    top: 0;\n    right: 0;\n}\n\n.tituloYouCofee{\n   width: 100%;\n   text-align: center;\n   \n   \n}\n\n.tituloYouCoffee h1{\n    width: 100%;\n    font-size: 55px;\n    margin-top: 0;\n    margin-bottom: 20px;\n    color:#9E184B;\n    font-family: 'MonstserratBlack', sans-serif;\n}\n\n@media (max-width: 480px) {\n    .imagemCafe{\n        width: 0%;\n        top: 0;\n        right: 0;\n    }\n\n    .imagemTopo{\n     align-items: center;   \n     margin-left: 16%;\n    }\n }\n\n.imagemLogoYoux{\n    width: 9%;\n    top: 0;\n    left: 0;\n    margin-top: 60px;\n    margin-left: 70px;\n    position: absolute;\n}\n\n.imagemXicara{\n    position: absolute;\n     width: 19%;\n    bottom: 0;\n    left: 0;\n    border-radius: 20%;\n}\n\n.buttonEdit{\n    width: 67%;\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    margin-top: 50px;\n}\n\n.caixaInput{\n    width: 100%;\n    margin-top: 10px;\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n    \n}\n\n.subTitulo{\n    font-size: 20px;\n    margin-bottom: 6px;\n}\n\n.caixaAllInput{\n    width: 67%;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page": `AutentificacaoCadastro_page__vFXEu`,
	"container": `AutentificacaoCadastro_container__LbQwc`,
	"sect": `AutentificacaoCadastro_sect__UVwFQ`,
	"imagemCafe": `AutentificacaoCadastro_imagemCafe__T+Lqa`,
	"tituloYouCofee": `AutentificacaoCadastro_tituloYouCofee__XAMvD`,
	"tituloYouCoffee": `AutentificacaoCadastro_tituloYouCoffee__XwWPB`,
	"imagemTopo": `AutentificacaoCadastro_imagemTopo__Ip8u7`,
	"imagemLogoYoux": `AutentificacaoCadastro_imagemLogoYoux__WwTB5`,
	"imagemXicara": `AutentificacaoCadastro_imagemXicara__CtQjc`,
	"buttonEdit": `AutentificacaoCadastro_buttonEdit__h0Iut`,
	"caixaInput": `AutentificacaoCadastro_caixaInput__N1MuA`,
	"subTitulo": `AutentificacaoCadastro_subTitulo__RQ9vW`,
	"caixaAllInput": `AutentificacaoCadastro_caixaAllInput__dq+aL`
};
export default ___CSS_LOADER_EXPORT___;
